export default "__VITE_ASSET__BZXkfR9T__"